/* lystia-core.js — ядро теми Lystia (T-E2-09). Підключення: <script src="{{ 'lystia-core.js' | asset_url }}" defer>.
   Без глобального рантайму прототипу; публічне API: document.lystia. Події — CustomEvent на document:
   lystia:cart-change, lystia:fav-change, lystia:overlay-open, lystia:overlay-close, lystia:device-change.
   API: on(evt, fn) -> off · off(evt, fn) · emit(evt, detail) · store.get/set/remove · scrollLock.lock/unlock/locked
        device() · reducedMotion() · debounce(fn, ms=150) · reveal(root) */
(function () {
  'use strict';
  if (document.lystia) return;

  /* ---- Події (CustomEvent на document; імена без префікса -> 'lystia:' + name) ---- */
  const evName = (e) => (String(e).indexOf('lystia:') === 0 ? String(e) : 'lystia:' + e);
  const wrappers = new Map(); /* fn -> {evt -> wrapper} */
  function off(evt, fn) {
    const m = wrappers.get(fn);
    const name = evName(evt);
    if (!m || !m[name]) return;
    document.removeEventListener(name, m[name]);
    delete m[name];
  }
  function on(evt, fn) {
    const name = evName(evt);
    const w = (e) => { try { fn(e.detail, e); } catch (err) { console.error('[lystia ' + name + ']', err); } };
    const m = wrappers.get(fn) || {};
    if (m[name]) document.removeEventListener(name, m[name]);
    m[name] = w;
    wrappers.set(fn, m);
    document.addEventListener(name, w);
    return () => off(evt, fn);
  }
  function emit(evt, detail) {
    document.dispatchEvent(new CustomEvent(evName(evt), { detail: detail }));
  }

  /* ---- Утиліти ---- */
  const mqDesktop = window.matchMedia('(min-width: 1024px)');
  const device = () => (mqDesktop.matches ? 'desktop' : 'mobile');
  const reducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const debounce = (fn, ms) => {
    const wait = ms == null ? 150 : ms;
    let t;
    return function () { const a = arguments, self = this; clearTimeout(t); t = setTimeout(() => fn.apply(self, a), wait); };
  };
  const onMq = () => { document.documentElement.dataset.device = device(); emit('device-change', device()); };
  if (mqDesktop.addEventListener) mqDesktop.addEventListener('change', onMq); else mqDesktop.addListener(onMq);
  document.documentElement.dataset.device = device();

  /* ---- Store: localStorage у try/catch + пам'ять (приватний режим, previews), префікс lystia: ---- */
  const mem = {};
  const PFX = 'lystia:';
  const store = {
    get(k, def) {
      try { const v = localStorage.getItem(PFX + k); if (v != null) return JSON.parse(v); } catch (e) { /* недоступне -> пам'ять */ }
      return k in mem ? mem[k] : def;
    },
    set(k, v) { mem[k] = v; try { localStorage.setItem(PFX + k, JSON.stringify(v)); } catch (e) { /* ignore */ } return v; },
    remove(k) { delete mem[k]; try { localStorage.removeItem(PFX + k); } catch (e) { /* ignore */ } },
  };

  /* ---- Scroll-lock (iOS-safe, лічильник для вкладених блокувань) ---- */
  let lockCount = 0, lockY = 0;
  const scrollLock = {
    lock() {
      if (lockCount++ > 0) return;
      lockY = window.scrollY;
      document.body.style.top = -lockY + 'px';
      document.body.classList.add('is-locked');
    },
    unlock() {
      if (lockCount === 0 || --lockCount > 0) return;
      document.body.classList.remove('is-locked');
      document.body.style.top = '';
      window.scrollTo(0, lockY);
    },
    get locked() { return lockCount > 0; },
  };

  /* ---- Reveal: .reveal -> .is-in через IntersectionObserver ---- */
  let io = null;
  function reveal(root) {
    const scope = root || document;
    const els = Array.prototype.slice.call(scope.querySelectorAll('.reveal:not(.is-in)'));
    if (!els.length) return;
    if (!('IntersectionObserver' in window) || reducedMotion()) { els.forEach((e) => e.classList.add('is-in')); return; }
    io = io || new IntersectionObserver((entries) => entries.forEach((en) => {
      if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
    }), { rootMargin: '0px 0px -8% 0px', threshold: 0.01 });
    els.forEach((e) => io.observe(e));
  }

  document.lystia = Object.freeze({ on, off, emit, store, scrollLock, device, reducedMotion, debounce, reveal });

  /* Автозапуск reveal + секції в редакторі теми */
  const initReveal = () => reveal(document);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initReveal); else initReveal();
  document.addEventListener('shopify:section:load', (e) => reveal(e.target));
})();
